import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Session from '../../utils/session.service';
import UserRestServices from '../../services/user-rest.service';

@Component({
	standalone: true,
	selector: 'modal-switch-to-admin-assistant',
	templateUrl: './modal-switch-to-admin-assistant.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export class ModalSwitchToAdminAssistantComponent implements OnInit {
	private session: Session = inject(Session);
	private userRestServices: UserRestServices = inject(UserRestServices);
	private dialogRef = inject(MatDialogRef<ModalSwitchToAdminAssistantComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.handleModalInit();
		
		this.vm.handleModalClose = this.handleModalClose;
		this.vm.handleModalSubmit = this.handleModalSubmit;
	}
	
	handleModalInit() {
		this.vm.user = this.session.getSession().user;
	}
	
	handleModalSubmit() {
		if (this.vm.processing) return;
		this.vm.processing = true;
		
		this.userRestServices.switchToAdminAssistant({},
			() => {
				window.location.href = window.location.href.split('#')[0];
			},
			(error) => {
				console.error('Failed switching to admin assistent', error);
				this.vm.processing = false;
			}
		);
	}
	
	handleModalClose() {
		this.dialogRef.close(this.vm.user);
	}
	
}